import { SHIFTS } from "@/constants/shifts";

const emptyShift = () => ({ customerQuantity: 0, restaurantQuantity: 0, totalQuantity: 0 });

/**
 * Obroci iz odgovora "order-more-restaurants" (stavke: restoran × poslovnica, svaka sa `meals`) zbirno po obroku:
 * količine kupaca / restorana po smenama i ukupno. Isti obrok iz više stavki se sabira.
 */
export const aggregateMealEntries = (entries, toLatin = (value) => value) => {
  const mealMap = new Map();

  entries.forEach((entry) => {
    (entry.meals || []).forEach((meal) => {
      const key = meal.id || `name_${meal.name}`;

      if (!mealMap.has(key)) {
        const shifts = SHIFTS.reduce((acc, shift) => ({ ...acc, [shift.key]: emptyShift() }), {});
        mealMap.set(key, {
          id: meal.id,
          name: toLatin(meal.name),
          type: meal.type || null,
          num: mealMap.size + 1,
          ...shifts,
          total: 0,
        });
      }

      const mealData = mealMap.get(key);
      SHIFTS.forEach((shift) => {
        const shiftKey = shift.key;
        mealData[shiftKey].customerQuantity += meal[shiftKey]?.customerQuantity || 0;
        mealData[shiftKey].restaurantQuantity += meal[shiftKey]?.restaurantQuantity || 0;
        mealData[shiftKey].totalQuantity += meal[shiftKey]?.totalQuantity || 0;
      });
      mealData.total += meal.total || 0;
    });
  });

  return Array.from(mealMap.values());
};

/** Zbir obroka po smenama i ukupno (isti oblik kao `totals` iz odgovora). */
export const totalMeals = (meals) => {
  const totals = SHIFTS.reduce((acc, shift) => ({ ...acc, [shift.key]: emptyShift() }), { total: 0 });
  meals.forEach((meal) => {
    SHIFTS.forEach((shift) => {
      totals[shift.key].customerQuantity += meal[shift.key]?.customerQuantity || 0;
      totals[shift.key].restaurantQuantity += meal[shift.key]?.restaurantQuantity || 0;
      totals[shift.key].totalQuantity += meal[shift.key]?.totalQuantity || 0;
    });
    totals.total += meal.total || 0;
  });
  return totals;
};
